import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerLocationID } from "models";

export const useTyreTeamCredentialsQuery = (locationId: DealerLocationID) =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.tyreTeamCredentials(locationId),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.tyre_team_credentials ?? []
  });
